/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Listing_Error_Size_GenericInputs */

const en_create_listing_error_size_generic = /** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exceeds the 50MB limit for secure vault storage.`)
};

const es_create_listing_error_size_generic = /** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`supera el límite de 50MB para el almacenamiento seguro en la bóveda.`)
};

const fr_create_listing_error_size_generic = /** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dépasse la limite de 50 Mo pour le stockage sécurisé dans le coffre-fort.`)
};

const de_create_listing_error_size_generic = /** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`überschreitet das 50MB-Limit für den sicheren Vault-Speicher.`)
};

const id_create_listing_error_size_generic = /** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`melebihi batas 50MB untuk penyimpanan Vault yang aman.`)
};

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const ja_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const zh_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const ar_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const it_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const ru_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const pt_create_listing_error_size_generic = en_create_listing_error_size_generic;

/** @type {(inputs: Create_Listing_Error_Size_GenericInputs) => LocalizedString} */
const ko_create_listing_error_size_generic = en_create_listing_error_size_generic;

/**
* | output |
* | --- |
* | "exceeds the 50MB limit for secure vault storage." |
*
* @param {Create_Listing_Error_Size_GenericInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_listing_error_size_generic = /** @type {((inputs?: Create_Listing_Error_Size_GenericInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Listing_Error_Size_GenericInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_listing_error_size_generic(inputs)
	if (locale === "es") return es_create_listing_error_size_generic(inputs)
	if (locale === "fr") return fr_create_listing_error_size_generic(inputs)
	if (locale === "de") return de_create_listing_error_size_generic(inputs)
	if (locale === "ja") return ja_create_listing_error_size_generic(inputs)
	if (locale === "zh") return zh_create_listing_error_size_generic(inputs)
	if (locale === "ar") return ar_create_listing_error_size_generic(inputs)
	if (locale === "id") return id_create_listing_error_size_generic(inputs)
	if (locale === "it") return it_create_listing_error_size_generic(inputs)
	if (locale === "ru") return ru_create_listing_error_size_generic(inputs)
	if (locale === "pt") return pt_create_listing_error_size_generic(inputs)
	return ko_create_listing_error_size_generic(inputs)
});